module.exports = __webpack_public_path__ + "img/yureka_logo.5bdbfc36.png";